export const sortTypeMapper = (type) => {
    if (!type) return undefined;
    return type === 'ascend' ? 'asc' : 'dsc';
}